import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { ChevronDown } from "lucide-react";

export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[680px] w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center animate-slow-zoom"
          style={{
            backgroundImage:
              "url(/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_Cover-2_2880x2304.jpg)"
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a2424]/85 via-[#0a2424]/55 to-[#0a2424]/95" />
        <div className="absolute inset-0 grain-overlay" />
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-5 lg:px-10 flex flex-col justify-center items-center text-center">
        <div className="animate-fade-up" style={{ animationDelay: "0.1s", opacity: 0 }}>
          <span className="divider-ornament text-spice-gold">Coastal Fusion Dining</span>
        </div>

        <h1
          className="font-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium tracking-tight mt-6 mb-4 leading-[1.05] max-w-5xl animate-fade-up"
          style={{ animationDelay: "0.25s", opacity: 0 }}
        >
          Where the Coast Meets the <span className="italic text-spice-gold font-light">Kitchen</span>
        </h1>

        <p
          className="text-white/85 text-lg md:text-xl tracking-wide font-light max-w-2xl animate-fade-up"
          style={{ animationDelay: "0.45s", opacity: 0 }}
        >
          Cafe by morning. Restaurant by night. Licensed bar always ready. Sea Spice Kitchen brings
          bold coastal flavours to the heart of Frankston.
        </p>

        <div
          className="flex flex-wrap items-center justify-center gap-3 mt-4 mb-6 text-white/70 text-xs sm:text-sm tracking-[0.25em] uppercase animate-fade-up"
          style={{ animationDelay: "0.6s", opacity: 0 }}
        >
          <span>Fresh Seafood</span>
          <span className="text-spice-gold">•</span>
          <span>Global Flavours</span>
          <span className="text-spice-gold">•</span>
          <span>Memorable Experiences</span>
          
        </div>
       <div
  className="flex flex-wrap justify-center items-center gap-3 text-sm md:text-base uppercase tracking-[0.25em] font-semibold mb-8 animate-fade-up"
  style={{ animationDelay: "0.65s", opacity: 0 }}
>
  <span className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md">
    Open 7 Days
  </span>

  <Link to="/menu" className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md hover:bg-spice-gold hover:text-[#0d2929] transition-colors">
    Breakfast
  </Link>  

  <Link to="/menu" className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md hover:bg-spice-gold hover:text-[#0d2929] transition-colors">
    Lunch
  </Link>

  <Link to="/menu" className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md hover:bg-spice-gold hover:text-[#0d2929] transition-colors">
    Dinner
  </Link>
  <Link to="/drinks-menu" className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md hover:bg-spice-gold hover:text-[#0d2929] transition-colors">
    Bar
  </Link>

  <Link to="/beverages-menu" className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md hover:bg-spice-gold hover:text-[#0d2929] transition-colors">
    Coffee
  </Link>
</div>
       
        <div
          className="flex flex-col sm:flex-row items-center gap-4 animate-fade-up"
          style={{ animationDelay: "0.75s", opacity: 0 }}
        >
          <Link to="/reservations">
            <Button className="bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold tracking-wide rounded-none px-10 h-14 text-sm">
              Book Your Table Today
            </Button>
          </Link>
          <Link to="/menu">
            <Button
              variant="outline"
              className="bg-transparent border-white/40 text-white hover:bg-white hover:text-[#0d2929] hover:border-white tracking-wide rounded-none px-10 h-14 text-sm"
            >
              View Our Menus
            </Button>
          </Link>
          <a href="tel:+61370572373">
            <Button
              variant="outline"
              className="bg-transparent border-white/40 text-white hover:bg-white hover:text-[#0d2929] hover:border-white tracking-wide rounded-none px-10 h-14 text-sm"
            >
              Call (03) 7057 2373
            </Button>
          </a>
        </div>

        <div
          className="mt-6 mx-auto w-full max-w-[600px] animate-fade-up"
          style={{ animationDelay: "0.9s", opacity: 0 }}
        >
          <img
            src="/image/siteimages/Home/kidspromo/Sea Spice Kitchen - Kids Promo Strip 1200x200 @2x (1).png"
            alt="Sea Spice Kitchen kids meal promotion"
            className="mx-auto block w-full h-auto"
          />
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 flex flex-col items-center gap-2 animate-fade-up" style={{ animationDelay: "1s", opacity: 0 }}>
        <span className="text-[10px] tracking-[0.4em] uppercase">Scroll</span>
        <ChevronDown size={18} className="animate-bounce" />
      </div>
    </section>
  );
}
